import { Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export default function RecordingProcessingFailureMessage() {
  return (
    <Stack ml={'sm'} gap="xxs" maw={400}>
      <Text size="sm" c="red.7" fw={FONT_WEIGHTS.semibold}>
        Failed to process recording
      </Text>
      <Text size="sm" c="gray.7">
        There was an error processing your recording.
        <br />
        Please contact support for assistance.
      </Text>
    </Stack>
  );
}
